.bq{right:0px;}